import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";

const BanquetLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-castle-cream-200">
      <main className="flex-1 flex flex-col" role="main">
        <Outlet />
      </main>
      <div className="flex-none">
        <Footer />
      </div>
    </div>
  );
};

export default BanquetLayout; 